import {
  createMuiTheme,
  darken,
  responsiveFontSizes,
} from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';

const theme = createMuiTheme({
  font: {
    regular: 'proxima_novaregular',
    medium: 'proxima_novamedium',
    bold: 'proxima_novabold',
    light: 'proxima_novalight',
    semiBold: 'proxima_novasemibold',
    secondary: 'Lato',
  },
  name: 'Blue Panther',
  palette: {
    background: {
      sidebarActiveItem: '#F5F6FA',
      defaultLightGrey: '#F5F6FA',
      primary: {
        light: '#00a8ff29',
        main: darken('#00a8ff29', 0.2),
        dark: darken('#00a8ff29', 0.4),
      },
      warning: {
        light: '#fff17633',
        main: darken('#fff17633', 0.2),
        dark: darken('#fff17633', 0.4),
      },
      error: {
        light: '#e5737333',
        main: darken('#e5737333', 0.2),
        dark: darken('#e5737333', 0.4),
      },
    },
    primary: {
      light: '#65bffb',
      main: '#00a8ff',
      dark: '#4476fd',
    },
    secondary: {
      light: '#65bffb',
      main: '#00a8ff',
      dark: '#4476fd',
    },
    link: {
      enabled: '#2779f6',
    },
    type: 'dark',
  },
  typography: {
    fontFamily: 'proxima_novaregular',
    button: {
      textTransform: 'none',
    },
  },
  spacing: 4,
  overrides: {
    MuiTabs: {
      root: {
        borderBottom: 'none',
      },
      indicator: {
        backgroundColor: 'transparent',
      },
    },
    MuiTab: {
      root: {
        color: 'black',
        textTransform: 'none',
        background: 'none',
        '&:hover': {
          backgroundColor: grey[200],
        },
        '&:focus': {
          color: 'black',
        },
        '&$selected': {
          backgroundColor: '#ffffff',
          boxShadow: '1px 1px 5px rgba(100,100,100,0.2)',
        },
      },
    },
  },
});

export default responsiveFontSizes(theme);
